import React from "react";
import bejo from "../../../../assets/img/cards/bejo.jpg";
import alex from "../../../../assets/img/cards/alex.jpg";
import chess from "../../../../assets/img/cards/chess.jpg";
import "./WhyComplend.css";
import { useFade } from "../../../../hooks/useFade";

export const WhyComplend = ({ data, images }) => {
  useFade("up", [".fade-up"]);
  const defaultCardsData = [
    {
      id: 1,
      title: "Bezhan Kalichava",
      description:
        "Bezhan Kalichava is a Full-stack JavaScript Developer with a strong focus on blockchain technology. He has played a key role in developing crypto market platforms, utilizing his expertise in smart contracts, decentralized applications, and Web3 interactions. Bezhan's hands-on experience includes implementing blockchain-based user registration and staking systems, as well as creating secure, modular systems for trading and managing cryptocurrencies. His background in both technical and managerial roles equips him with the skills to lead projects and teams effectively in the blockchain space.",
      image: bejo,
    },
    {
      id: 2,
      title: "Alexandre Phiphia",
      description:
        "Alexandre Phiphia is a Full-stack JavaScript Developer with a strong focus on blockchain technology. He has played a key role in developing crypto market platforms, utilizing his expertise in smart contracts, decentralized applications, and Web3 interactions. Alexandre's hands-on experience includes implementing blockchain-based user registration and staking systems, as well as creating secure, modular systems for trading and managing cryptocurrencies. His background in both technical and managerial roles equips him with the skills to lead projects and teams effectively in the blockchain space.",
      image: alex,
    },
  ];

  return (
    <div className="whyComplend__container">
      <div className={`whyComplend__cardContent`}>
        <div className={`whyComplend__cardHeader fade-up`}>Meet Our Team</div>
        <div className={`whyComplend__cardsWrapper`}>
          {defaultCardsData?.map((item) => (
            <div
              className={`whyComplend__card whyComplend__green fade-up`}
              key={item.id}
            >
              <div className={`whyComplend__imgWrapper fade-up`}>
                <img
                  className={`whyComplend__cardImg`}
                  src={item.image}
                  alt={"img"}
                />
              </div>
              <div className={`whyComplend__cardInfo fade-up`}>
                <h2 className={`whyComplend__cardTitle`}>{item.title}</h2>
                <p className={`whyComplend__cardText`}>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* <img src={BitcoinCard} className={"whyComplend__bottom"} alt="img" /> */}
    </div>
  );
};
